import { Container } from "./styles";

import profileImage from "../../assets/profile-image.jpg";
import cssIcon from "../../assets/icons/css-icon.svg";
import htmlIcon from "../../assets/icons/html-icon.svg";
import jsIcon from "../../assets/icons/js-icon.svg";
import arduinoIcon from "../../assets/icons/arduino-icon.svg";
import reactIcon from "../../assets/icons/react-icon.svg";
import typescriptIcon from "../../assets/icons/typescript-icon.svg";
import bootstrapIcon from "../../assets/icons/bootstrap-icon.svg";
import flaskIcon from "../../assets/icons/flask-icon.svg";
import mysqlIcon from "../../assets/icons/mysql-icon.svg";
import illustratorIcon from "../../assets/icons/illustrator-icon.svg";
import photoshopIcon from "../../assets/icons/photoshop-icon.svg";
import pythonIcon from "../../assets/icons/python-icon.svg";
import ScrollAnimation from "react-animate-on-scroll";

export function About() {
  return (
    <Container id="about">
      <div className="about-text">
        <ScrollAnimation animateIn="fadeInLeft">
          <h2>Tangled Platform</h2>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInLeft" delay={0.2 * 1000}>
          <p>
          Tangled is a distributed ledger technology that uses a directed acyclic graph (DAG) data structure and
           blockchain data structure to achieve its goals of decentralization, transparency, and immutability in the
            healthcare sector. </p>
            <p>DAGs offer a promising approach to improve the existing speed, scalability, and cost 
            issues of blockchain technology and vice versa. Tangled data analizing sector includes a neural network 
            where NLP techniques acts as its batch normalization layer 
            and other process that could act as a Decentralized Autonomous Organization (DAO) on 
            their own, providing transparency and accountability. 
          </p>
        </ScrollAnimation>
        <ScrollAnimation
          animateIn="fadeInLeft"
          delay={0.4 * 1000}
          style={{ marginTop: "2rem", marginBottom: "2rem" }}
        >
          <p>
          which makes it faster and more efficient than 
            traditional systems. Tangled also explores its potential use cases in NFTs.
          </p>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInLeft" delay={0.6 * 1000}>
          
        </ScrollAnimation>

        <ScrollAnimation animateIn="fadeInLeft" delay={0.7 * 1000}>
          <h3></h3>
        </ScrollAnimation>
        <div className="hard-skills">
          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.1 * 1000}>
             
            </ScrollAnimation>
          </div>

          <div className="hability">
            <ScrollAnimation animateIn="fadeInUp" delay={0.7 * 1000}>
              
            </ScrollAnimation>
          </div>
        </div>
      </div>
      <div className="about-image">
        <ScrollAnimation animateIn="fadeInRight" delay={0.6 * 1000}>
          <img
            src="https://media4.giphy.com/media/MAWKf4CcnrwBk4tsr9/giphy.gif?cid=790b76119b8317c180d4c5835273ad434ff1054c8ca77d98&rid=giphy.gif&ct=s"
            alt="Imagem de perfil"
          />
        </ScrollAnimation>
      </div>
    </Container>
  );
}
